import {
  getWorkUnitByTokenRecursive,
  getWorkUnitByTokenService,
} from 'src/components/pages/sales/business-rule/helper/getWorkUnitByTokenRecursive'

export const getCurrentWorkUnit = async (work_unit_nodes, token_work_unit, setLoadingWorkUnits = null) => {
  try {
    if (token_work_unit?.length){
      const list_work_unit_nodes = token_work_unit.map((token) => {
        let work_unit = getWorkUnitByTokenRecursive(work_unit_nodes, token)
        if (work_unit) {
          const mapper_work_unit = {
            ...work_unit,
            token: work_unit.value,
            long_name: work_unit.label,
          }
          return mapper_work_unit
        }
      })
      if (list_work_unit_nodes.length){
        return list_work_unit_nodes
      }

      setLoadingWorkUnits && setLoadingWorkUnits(true)
      const list_work_unit_nodes_service = token_work_unit.map(async (token) => {
        let work_unit = await getWorkUnitByTokenService(token)
        if (work_unit) {
          return work_unit
        }
      })
      setLoadingWorkUnits && setLoadingWorkUnits(false)
      if (list_work_unit_nodes_service) {
        return list_work_unit_nodes_service
      }
    }
    return null
  } catch (error) {
    setLoadingWorkUnits && setLoadingWorkUnits(false)
  }
}
